<template>
    <div class="form-field form-numeric" :rel="name" v-bind:class="{'has-suffix': suffix, 'form-required': requiredForm, 'form-focus': focus, 'form-disabled':isDisabled}">
        <div class="form-label" v-show="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper">
                <button @click="removeOne()"><span class="icon icon-icon_minus"></span></button>
                <input type="number"
                       :step="stepValue"
                       value="0"
                       :disabled="isDisabled"
                       v-model="internalValue"
                       :placeholder="placeholder"
                       @focus="focus=true"
                       @blur="focus=false"/>
                <button @click="addOne()"><span class="icon icon-icon_plus"></span></button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['value','label','name','placeholder','suffix', 'step','required','default','disabled'],
        data: function () {
            return {
                internalValue: '',
                oneTime: null,
                focus: false
            }
        },
        created: function() {
            this.internalValue = !isNaN(this.value) ? this.value : 0;
            this.stepValue = this.step ? this.step : 1
            this.requiredForm = this.required && this.required == 'true' ? true : false
            this.defaultValue = this.default || 1;
            this.isDisabled = this.disabled && (this.disabled == 'true' || this.disabled == true) ? true : false
        },
        methods: {
            removeOne: function(){
              if( this.isDisabled ){ return false; }
                this.internalValue = parseInt(this.internalValue) ? parseInt(this.internalValue) : 0
                this.internalValue = parseInt(this.internalValue) - this.stepValue
                this.internalValue = this.internalValue <= 0 ? 0 : this.internalValue
            },
            addOne: function(){
              if( this.isDisabled ){ return false; }
                this.internalValue = parseInt(this.internalValue) ? parseInt(this.internalValue) : 0
                this.internalValue = parseInt(this.internalValue) + this.stepValue
            }
        },
        watch: {
            'value'(newVal, oldVal) {
              if( this.internalValue != newVal )
              {
                console.log("NUMERIC value: ", this.internalValue, newVal, oldVal)
                this.internalValue = newVal;
                this.internalValue = this.internalValue === undefined || this.internalValue === null ? this.defaultValue : this.internalValue;
              }
            },
            'internalValue'(newVal, oldVal) {
                if( newVal !== null && newVal !== undefined ){
                    let diff = Math.round(newVal%this.stepValue*100)/100
                    diff = diff >= this.stepValue ? 0 : diff
                    console.log("NUMERIC internalValue: ", newVal, this.stepValue, Math.round(newVal%this.stepValue*100)/100)
                    this.internalValue = newVal - diff;
                    // Why ?
                    //this.internalValue = this.internalValue == 0 || !this.internalValue ? this.defaultValue : this.internalValue;
                }
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Numeric.vue